import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { UserRoutingModule } from './user-routing.module';
import { UserProfilePageComponent } from './pages/user-profile/user-profile.page.component';

@NgModule({
    declarations: [
        UserProfilePageComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        UserRoutingModule
    ],
    exports: [
        UserProfilePageComponent
    ]
})
export class UserModule { }
